import * as THREE from 'three';
import React, { useRef } from 'react'
import { RoundedBox, Text } from '@react-three/drei'
import { useFrame } from '@react-three/fiber';

import { const_var } from '../../../../redux/reducers/reducer';

const DimensionValue = ({ type, dir, position, rotation, value, slopeAngle, checkBackSide, limitX, limitY, cmpPosZ }) => {
    const ref_measure = useRef();
    const panelLength = [...value].length * 0.4;
    const panelHeight = 0.7;
    const panelThickness = 0.15;

    let newPosX = position[0];
    let newPosY = position[1];
    let newPosZ = position[2];

    useFrame(() => {
        if (ref_measure.current) {
            const distance = (const_var.controls !== undefined && const_var.controls.getDistance !== undefined)? const_var.controls.getDistance([0, 0, 0]):[0, 0, 0];

            let scaleFactor = distance / 80;
            if (cmpPosZ && cmpPosZ <= 0) scaleFactor = (distance - cmpPosZ) / 80;
            
            if (type) {
                if (type === 'window') {
                    if (dir === 'left') {
                        if (rotation[2] === 0) {
                            newPosX = position[0] - (panelLength / 2 * scaleFactor + 0.1);
                            newPosY =  position[1] - panelHeight / 2 * scaleFactor;
                        } else {
                            newPosX = position[0] - 0.1;
                        }
                    }
                    else if (dir === 'right') {
                        if (rotation[2] === 0) {
                            newPosX = position[0] + (panelLength / 2 * scaleFactor + 0.1);
                            newPosY = position[1] - panelHeight / 2 * scaleFactor;
                        } else {
                            newPosX = position[0] + 0.1;
                        }
                    }
                    else if (dir === 'top') {
                        newPosY = position[1] + panelHeight * scaleFactor * 1.35;
                    }
                    else if (dir === 'bottom') {
                        newPosY = position[1] - panelHeight * scaleFactor * 1.35
                    }
                } else if (type === 'door') {
                    if (dir === 'left') {
                        if (rotation[2] === 0) {
                            newPosX = position[0] - (panelLength / 2 * scaleFactor * 1.5 + 0.2);
                        } else {
                            newPosX = position[0] - 0.1;
                        }
                    }
                    else if (dir === 'right') {
                        if (rotation[2] === 0) {
                            newPosX = position[0] + (panelLength / 2 * scaleFactor * 1.5 + 0.2);
                        } else {
                            newPosX = position[0] + 0.1;
                        }
                    }
                    else if (dir === 'top') {
                        newPosY = position[1] + panelHeight * scaleFactor * 1.35;
                    } else {

                    }
                }
            }
            
            ref_measure.current.position.set(newPosX, newPosY, newPosZ);
            ref_measure.current.scale.set(scaleFactor, scaleFactor, 1);
        }
    });

    return (
        <group ref={ref_measure} rotation={rotation}>
            <group position={[0, 0.5, 0.2]} rotation={[-THREE.MathUtils.degToRad(slopeAngle), 0, 0]}>
                <RoundedBox args={[panelLength, panelHeight, panelThickness]} radius={0.075}  scale={[1, 1, 0.1]}>
                    <meshStandardMaterial color={'#2270B3'}  />
                </RoundedBox>
                <Text
                    color="white"
                    anchorX="center" 
                    anchorY="middle" 
                    fontSize={0.5}
                    fontWeight={500}
                    position={[0,0,0.02]}
                >
                    <meshBasicMaterial color={"#FFF"} fog={false} toneMapped={false}  />
                    {value}
                </Text>
                {checkBackSide &&
                    <Text
                        color="white"
                        anchorX="center" 
                        anchorY="middle" 
                        fontSize={0.5}
                        fontWeight={500}
                        position={[0,0,-0.02]}
                        rotation={[0, Math.PI, 0]}
                    >
                        <meshBasicMaterial color={"#FFF"} fog={false} toneMapped={false}  />
                        {value}
                    </Text>
                }
            </group>
        </group>
    )
}

export default DimensionValue